import React from 'react';
import { Box, VStack } from '@gluestack-ui/themed';

import { MeetingLobby } from '@/common/components/meeting/MeetingLobby';
import type { MeetingJoinSettings } from '@/common/components/meeting/types';

import { LecturerPresenceSetup } from './LecturerPresenceSetup';

export type LecturerPresenceSetupGateProps = {
  deviceCheckDone: boolean;
  onDeviceCheckJoin: (settings: MeetingJoinSettings) => void;
  savedPhotoUrl: string | null;
  savedPhotoResolving: boolean;
  savedPhotoLoadFailed: boolean;
  retrySavedPhotoLoad: () => void;
  handlePresenceConfirm: (args: { imageBase64: string; saveAsProfile: boolean }) => void | Promise<void>;
};

/**
 * Private lecturer setup before any shared LiveKit room join: device validation first,
 * then avatar reuse/capture. Students never see the lecturer tile during this flow.
 */
export function LecturerPresenceSetupGate({
  deviceCheckDone,
  onDeviceCheckJoin,
  savedPhotoUrl,
  savedPhotoResolving,
  savedPhotoLoadFailed,
  retrySavedPhotoLoad,
  handlePresenceConfirm,
}: LecturerPresenceSetupGateProps) {
  if (!deviceCheckDone) {
    return (
      <Box flex={1} testID="lecturer-presence-setup-gate">
        <MeetingLobby onJoin={onDeviceCheckJoin} />
      </Box>
    );
  }

  return (
    <VStack flex={1} p="$4" testID="lecturer-presence-setup-gate">
      <LecturerPresenceSetup
        onConfirm={handlePresenceConfirm}
        savedPhotoUrl={savedPhotoUrl}
        savedPhotoResolving={savedPhotoResolving}
        savedPhotoLoadFailed={savedPhotoLoadFailed}
        onRetrySavedPhotoLoad={retrySavedPhotoLoad}
      />
    </VStack>
  );
}
